<app-modal class="app-modal--contains-dropdown">
    <app-apply-tag [campaignId]="data.campaignId"
                   [targetType]="data.targetType"
                   [targetId]="data.targetId"
                   (changesSaved)="close()"
                   [tagCategory]="data.category"></app-apply-tag>
</app-modal>
